import { useState } from 'react'
import { CustomerApplication } from '../../../utilities/CustomerData'

import estimateRefundIcon from '../../../assets/ApplicationIcons/estimateRefundIcon.png'

export function ApplicationStep7({ _customerApplication, estimateRefund, step, setStep, handleApplicationStep7 }) {
  const customerApplication = new CustomerApplication(_customerApplication)

  const [last4SSN, setLast4SSN] = useState(customerApplication.last4SSN)
  const [confirmLast4SSN, setConfirmLast4SSN] = useState(customerApplication.last4SSN)
  const [birthYear, setBirthYear] = useState(customerApplication.birthYear)

  const [errors, setErrors] = useState({})

  const currentYear = new Date().getFullYear();
const years = Array.from({ length: 100 }, (_, i) => currentYear - i);

  const handleCheckApplicationStep7 = () => {
    const newErrors = {}

    if (!last4SSN) newErrors.last4SSN = 'Last 4 SSN is required'
    if (!confirmLast4SSN) newErrors.confirmLast4SSN = 'Please confirm Last 4 SSN'
    if (last4SSN !== confirmLast4SSN) newErrors.confirmLast4SSN = 'Last 4 SSNs do not match'
    if(!birthYear) newErrors.birthYear = 'Birth Year is required'

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors)
      return
    }

    handleApplicationStep7(last4SSN, birthYear)
  }

  return (
    <div className='w-11/12 h-full flex flex-col items-center lg:justify-center mt-8 mb-10'>
      {estimateRefund > 0 && (
        <div className='h-fit p-6 rounded-lg shadow-lg bg-gray-50 flex items-center gap-4 mb-4'>
          <div className='w-12 h-12 flex items-center justify-center rounded-full bg-secondaryColor object-contain'>
            <img 
              className='w-8 h-8' 
              src={estimateRefundIcon} 
              alt='Estimate Icon' 
            />
          </div>
          <div className='flex flex-col'>
            <p className='text-gray-600 text-sm font-medium'>Current Estimate</p>
            <p className='text-xl font-bold text-gray-900'>
              ${Number(estimateRefund).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </p>
          </div>
        </div>
      )}
      <p>To ensure the security of your application, we kindly request the last four digits of your Social Security Number (SSN) and birth year for validation purposes.</p>
      <p className='mt-4 mb-4'>Please note that upon approval, this information may be required for further verification throughout the process of receiving your SETC Refund.</p>
      <div className='w-1/2 max-sm:w-11/12 relative mb-4'>
        <p className='absolute text-sm bg-white left-3 top-[-5px]'>Last 4 Digits Of Your SSN Number</p>
        <input
          type='password'
          name='last4SSN'
          placeholder='XXXX'
          value={last4SSN}
          maxLength={4}
          onChange={(e) => {
            if (/^\d*$/.test(e.target.value))
              setLast4SSN(e.target.value)
          }}
          className={`mt-1 p-3 w-full border rounded-md shadow-sm focus:ring focus:ring-opacity-50 
                  ${errors.last4SSN ? 'border-red-500' : 'focus:ring-indigo-300'}`}
        />
        {errors.last4SSN && <p className='text-red-500 text-xs mt-1'>{errors.last4SSN}</p>}
      </div>
      <div className='w-1/2 max-sm:w-11/12 relative mb-4'>
        <p className='absolute bg-white left-3 top-[-5px] text-xs max-sm:text-[0.7rem] max-sm:top-[-4px]'>Confirm Last 4 Digits Of Your SSN Number</p>
        <input
          type='password'
          name='confirmLast4SSN'
          placeholder='XXXX'
          maxLength={4}
          value={confirmLast4SSN}
          onChange={(e) => {
            if (/^\d*$/.test(e.target.value))
              setConfirmLast4SSN(e.target.value)
          }}
          className={`mt-1 p-3 w-full border rounded-md shadow-sm focus:ring focus:ring-opacity-50 
                  ${errors.confirmLast4SSN ? 'border-red-500' : 'focus:ring-indigo-300'}`}
        />
        {errors.confirmLast4SSN && <p className='text-red-500 text-xs mt-1'>{errors.confirmLast4SSN}</p>}
      </div>
      <div className='w-1/2 max-sm:w-11/12 relative mb-4'>
        <label className='absolute text-sm bg-white left-3 top-[-5px]'>Birth Year</label>
        <select
          value={birthYear}
          onChange={(e) => setBirthYear(e.target.value)}
          className="mt-1 p-3 w-full border rounded-md shadow-sm focus:ring focus:ring-indigo-300"
        >
          <option value="">Select Year</option>
          {years.map((year) => (
            <option key={year} value={year}>{year}</option>
          ))}
        </select>
        {errors.birthYear && <p className='text-red-500 text-xs mt-1'>{errors.birthYear}</p>}
      </div>
      <div className='flex flex-row items-center gap-4'>
        <button
          onClick={() => setStep(step - 1)}
          className='flex flex-row items-center gap-2 px-8 py-2 text-white rounded-md transition-colors duration-200 mb-4 mt-10 bg-gray-400 hover:bg-gray-500'
        >
          Back
        </button>
        <button
          onClick={handleCheckApplicationStep7}
          className='flex flex-row items-center gap-2 px-8 py-2 text-white rounded-md transition-colors duration-200 mb-4 mt-10 bg-primaryColor hover:bg-primaryDarkColor'
        >
          Next
        </button>
      </div>
    </div>
  )
}